import {useEffect, useRef, useState} from 'react';
import {v4 as uuidv4} from 'uuid';
import Tabs from "rc-tabs";
import TabPane from "rc-tabs/lib/TabPanelList/TabPane";


import {ApiEventLabel, InfoLabel, SettingsLabel} from "../../../../config/Config";
import Alert from "../../../../modules/alert/Alert";

import Field from "../../../../modules/workflow/Field";
import UseGetterNodeValue from "../../hooks/UseGetterNodeValue";
import UseSetterNodeValue from "../../hooks/UseSetterNodeValue";
import {AllowTags} from "../../../../components/allow-tags";
import {Modal} from "../../../../components/modal";
import $ from "jquery";
import PerfectScrollbar from "react-perfect-scrollbar";
import {Error} from "./Error";
import ImageTasks from "../../../../resources/images/tasks.svg";
import Checkbox from "../../../../components/input/checkbox";
import {DELETE, GET, PATCH, POST, PUT} from "../Webservice/Methods";
import {getConsentTypes} from "../../../../components/input/query/segment";


let $linker = {}

const options = {
    buttonErase    : false,
    displayMode    : "original",
    associationMode: "oneToOne",
    lineStyle      : "square-ends",
}


const lists = [
    {
        "name": "Data Provider Fields",
        "list": []
    },
    {
        "name": "Audience Fields",
        "list": []
    }
]

const consentsDevices = [
    {value: 'mobile_phone', label: 'Mobile Phone'},
    {value: 'email_address', label: 'Email Address'},
]

const ApiEvent = ({journey, previousNode, currentNode}) => {

    const [error, setError] = useState('')
    const [modal, setModal] = useState({});
    const [consentTypes, setConsentTypes] = useState([]);
    const [fields, setFields] = useState(UseGetterNodeValue(currentNode, 'settings', 'fields', ['first_name', 'last_name', 'mobile_phone']));
    const [endpoint,] = useState(UseGetterNodeValue(currentNode, 'settings', 'endpoint', uuidv4()));
    const [showConsents, setShowConsents] = useState(UseGetterNodeValue(currentNode, 'settings', 'check_consents', false));


    const linkRef = useRef()
    const config = UseGetterNodeValue(currentNode, 'settings', 'config');



    lists[0].list = fields || []


    if (journey?.Audience?.fields?.length > 0) {
        const audience_fields = []
        journey.Audience.fields.map(field => {
            if (field?.field_target === 'audience') {
                audience_fields.push(field.name)
            }
        })
        lists[1].list = audience_fields;
    }


    const showMatcher = (ev) => {
        ev.preventDefault();
        setModal({
            type       : 'match',
            title      : 'Match Fields',
            description: 'Match the fields you want to store in the audience'
        });
    }

    const showFields = (ev) => {
        ev.preventDefault();
        setModal({
            type       : 'fields',
            title      : 'Allow Fields',
            description: 'Add below the fields you want to accept in your Api'
        });
    }

    const handleSave = () => {
        let result = {}
        if (modal?.type === 'match') {
            result = $linker.fieldsLinker("getLinks")
            setError(result?.links?.length <= 0 ? "You must define at least one relation" : "")

            UseSetterNodeValue(currentNode, 'settings', 'fields', fields)
            UseSetterNodeValue(currentNode, 'settings', 'config', result)
            UseSetterNodeValue(currentNode, 'settings', 'links', result?.links)
            UseSetterNodeValue(currentNode, 'settings', 'endpoint_key', endpoint)


        } else {

            UseSetterNodeValue(currentNode, 'settings', 'fields', fields)
            UseSetterNodeValue(currentNode, 'settings', 'endpoint_key', endpoint)
        }
    }


    const handleOnShow = () => {
        if (modal?.type === 'match') {
            $linker = $(linkRef.current)
            $linker.fieldsLinker("init", {
                options      : options,
                Lists        : [lists[0], lists[1]],
                existingLinks: config?.links
            });
        }
    }

    useEffect(() => {

        getConsentTypes(journey?.Audience, 'label').then((result) => {
            if(result?.values?.length > 0) {
                setConsentTypes(result.values)
            }
        })

        const nodeFields = currentNode?.data?.form?.tabs?.settings?.fields
        if (nodeFields?.links?.error?.length > 0) {
            setError(nodeFields.links?.error)
        }

        if (nodeFields?.fields?.error?.length > 0) {
            setError(nodeFields.fields?.error)
        }
    }, []);

    return (
        <div className="Form">
            <form className="FormComponent">
                <div className="max-width-500">
                    <Alert
                        className="alert-primary"
                        message="This component generates a dynamic endpoint through which you can launch this journey."
                        docs={{message: ' For more info you can ', path: '/docs/journeys/single-shoot/'}}
                    />


                    <div className="FieldsetTabs">
                        <Tabs defaultActiveKey="0">
                            <TabPane forceRender={true} key={'tab_settings'} tabKey={'tab_settings'} tab={SettingsLabel}>
                                <div>

                                    <Field
                                        tab='settings'
                                        required={true}
                                        name='start_date'
                                        label='Start date'
                                        node={currentNode}
                                        wrapper='form-group'
                                        type='datetime-local'
                                        placeholder='Choose start date'
                                    />

                                    <Field
                                        tab='settings'
                                        name='end_date'
                                        required={true}
                                        node={currentNode}
                                        label='Expire date'
                                        wrapper='form-group'
                                        type='datetime-local'
                                        placeholder='Choose expire date'
                                    />

                                    {modal?.type &&
                                        <Modal show={modal?.type?.length > 0} onShow={handleOnShow} onSave={handleSave} onClose={ev => setModal({})}>
                                            <div className="ModalRules">
                                                {modal?.type === 'fields' &&
                                                    <AllowTags
                                                        image={ImageTasks}
                                                        title={modal?.title}
                                                        description={modal?.description}
                                                        initialState={fields}
                                                        onChange={state => setFields(state)
                                                        }
                                                    />
                                                }
                                                {modal?.type === 'match' && <PerfectScrollbar>
                                                    <div className="text-center mb-5">
                                                        <h6>{modal.title}</h6>
                                                        <p>{modal.description}</p>
                                                    </div>
                                                    <div ref={linkRef}/>
                                                </PerfectScrollbar>
                                                }
                                            </div>
                                        </Modal>}


                                    <div className="d-flex mt-3 mb-3 me-1">
                                        <button className="btn btn-sm btn-primary me-2" onClick={showFields}>
                                            Allow Fields
                                        </button>
                                        <button className="btn btn-sm btn-primary " onClick={showMatcher}>
                                            Match Fields
                                        </button>
                                    </div>


                                    {error && <div className="mb-3">
                                        <Error message={error}/>
                                    </div>}


                                    <Field
                                        tab='settings'
                                        type='text'
                                        canCopy={true}
                                        required={true}
                                        label='Endpoint'
                                        node={currentNode}
                                        name='endpoint_key'
                                        wrapper='form-group'
                                        defaultValue={endpoint}
                                        prepend={`${process.env.REACT_APP_BASE_API}/dynamic/`}
                                    />

                                    <div className="mt-4 d-block"/>


                                    <Checkbox
                                        isReady={true}
                                        name="check_consents"
                                        label="Check Consents"
                                        value={showConsents ? 'on' : 'off'}
                                        onChange={ev => {
                                            setShowConsents(ev.target.checked);

                                            UseSetterNodeValue(
                                                currentNode,
                                                'settings',
                                                'check_consents',
                                                ev.target.checked
                                            )
                                        }}
                                    />

                                    {showConsents && <div className="mt-4">
                                        <Field
                                            tab="settings"
                                            name="device"
                                            type="select"
                                            label="Device type"
                                            wrapper="form-group"
                                            className="input-sm"
                                            placeholder="Choose one"
                                            classNamePrefix="input-sm"
                                            required={true}
                                            isMulti={false}
                                            isSearchable={false}
                                            options={consentsDevices}
                                            node={currentNode}
                                        />

                                        <Field
                                            tab="settings"
                                            name="scope"
                                            type="select"
                                            label="Scope"
                                            wrapper="form-group"
                                            className="input-sm"
                                            placeholder="Choose one"
                                            classNamePrefix="input-sm"
                                            required={true}
                                            isMulti={true}
                                            isSearchable={true}
                                            options={consentTypes}
                                            node={currentNode}
                                        />
                                    </div>}

                                </div>
                            </TabPane>
                            <TabPane forceRender={true} key={'tab_info'} tabKey={'tab_info'} tab={InfoLabel}>
                                <div>
                                    <Field
                                        disabled
                                        canCopy
                                        tab='info'
                                        name='id'
                                        type='text'
                                        label='Component Id'
                                        node={currentNode}
                                        wrapper='form-group'
                                        defaultValue={currentNode.id}
                                    />

                                    <Field
                                        tab='info'
                                        name='title'
                                        type='text'
                                        label='Title'
                                        node={currentNode}
                                        wrapper='form-group'
                                        defaultValue={ApiEventLabel}
                                        placeholder='Type an descriptive title'
                                    />

                                    <Field
                                        tab='info'
                                        name='description'
                                        type='textarea'
                                        label='Description'
                                        wrapper='form-group'
                                        className='form-control'
                                        placeholder='Type a short description'
                                        node={currentNode}
                                    />
                                </div>
                            </TabPane>
                        </Tabs>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default ApiEvent;